module.exports = __webpack_public_path__ + "static/media/doc.ac492e28.png";